import createApp from '@shopify/app-bridge';
import { AppLink, NavigationMenu } from '@shopify/app-bridge/actions';
import { getSessionToken } from '@shopify/app-bridge/utilities';
import store from '@/store';

export default class OpinewBridge {
  constructor(menu = []) {
    this.menu = menu;
    this.navigationMenu = null;
    this.host = new URLSearchParams(location.search).get('host');
    this.setConfig();
    this.shopifySessionToken = null;
  }

  setConfig() {
    this.config = {
      // The client ID provided for your application in the Partner Dashboard.
      apiKey: process.env.VUE_APP_SHOPIFY_PUBLIC_API_KEY,
      // The host of the specific shop that's embedding your app. This value is provided by Shopify as a URL query parameter that's appended to your application URL when your app is loaded inside the Shopify admin.
      host: this.host,
    };
  }

  setActive(index) {
    if (this.navigationMenu) {
      this.navigationMenu.set({
        active: index < 0 ? undefined : this.items[index],
      });
    }
  }

  init() {
    if (this.host) {
      this.app = createApp(this.config);
      this.items = this.menu.map(el => AppLink.create(this.app, el));

      // eslint-disable-next-line no-unused-vars
      this.navigationMenu = NavigationMenu.create(this.app, {
        items: this.items,
      });
      this.shopifySessionToken = this.getShopifySessionToken(this.app);
    }
  }

  getShopifySessionToken(app) {
    getSessionToken(app).then(token => {
      store.commit('auth/setShopifyToken', { token });
    });
  }
}
